import { Checkbox } from '@mui/material';
import React from 'react';
import { useTodos } from '../../../../context/TodoContext/TodoContext';

interface TodoCheckboxProps {
    id: string;
    checked: boolean;
}

const TodoCheckbox: React.FC<TodoCheckboxProps> = ({ id, checked }) => {
    const { toggleTodo } = useTodos();

    return (
        <Checkbox
            checked={checked}
            onChange={() => toggleTodo(id)}
            onClick={(e) => e.stopPropagation()}
            onDoubleClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
            }}
            size="small"
            sx={{
                my: 'auto',
                // color: 'primary.main',
                transition: 'transform 0.2s ease',
                '&:hover': {
                    transform: 'scale(1.1)',
                }
            }}
        />
    );
};

export default TodoCheckbox; 